<div class="emoji-container-box {{uiClass}}" [hidden]="!toggleEmoji">
  <emoji-mart
    [ngClass]="uiClass === 'col-lg-12' ? 'emoji-mart-expanded' : (uiClass === 'expanded-with-user-profile' ? 'emoji-mart-expanded-with-user-profile' : 'emoji-mart')"
    [set]="set" (emojiSelect)="openEmoji($event)" title="Pick your emoji…" (emojiOver)="onClickOutside()">
  </emoji-mart>
</div>
